const getFocusableElements = (refOrElement) => {
  const context = refOrElement?.current || refOrElement;

  const focusableElements = Array.from(
    context?.querySelectorAll(
      'button:not([disabled]), a:not([tabindex="-1"]), video, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable]',
    ),
  );

  return focusableElements;
};

export default getFocusableElements;
